import React from "react";
import { Text, Button, ModalBody, ModalFooter } from "@chakra-ui/react";
import { ClasswizeModal } from "./ui/Modal";
import { colours } from "@/utils/themeUtils";

interface Props {
	isOpen: boolean;
	onClose: () => void;

	focusName?: string;
	handleConfirmation: () => void;
}

export function ConfirmEndFocusModal(props: Props): JSX.Element {
	return (
		<ClasswizeModal isOpen={props.isOpen} onClose={props.onClose} size={"lg"} title={`End Focus`} dataTestId={"end-focus-modal"}>
			<ModalBody>
				<Text color={"#42526E"} lineHeight={"20px"}>
					You are about to remove the last student from the active Focus. This action will automatically end the{" "}
					{props.focusName && `"${props.focusName}"`} focus for all students.
				</Text>
				<Text fontWeight={500} color={colours.text.body} mt={8}>
					Are you sure you want to end the {props.focusName && `"${props.focusName}"`} focus?
				</Text>
			</ModalBody>
			<ModalFooter>
				<Button
					float={"right"}
					onClick={() => {
						props.handleConfirmation();
						props.onClose();
					}}
				>
					End Focus
				</Button>
			</ModalFooter>
		</ClasswizeModal>
	);
}
